<template>
  <div
    class="PageLogin"
    v-loading="loading"
    element-loading-text="please wait..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <el-form :rules="rules" ref="ruleForm" :model="ruleForm" label-width="0px">
      <div class="loginBox">
        <div class="loginInnerBox">
          <img
            src="../assets/img/qr-code-icon.png"
            style="float: right; font-size: 1.5rem; cursor: pointer"
            @click="showQRCode = !showQRCode"
          />
          <div class="loginTitle">
            <p class="icon">
              <img width="40%" src="../assets/img/400px-DELTA_Electronics_Logo.png" />
            </p>
            <p>Delta VAM Platform</p>
          </div>
          <div class="loginInput">
            <el-form-item label="" prop="NTAccount">
              <el-input v-model="ruleForm.NTAccount" placeholder="NT Account" @keyup.enter.native="login"> </el-input>
            </el-form-item>
            <el-form-item label="" prop="PS">
              <el-input v-model="ruleForm.PS" placeholder="Password" @keyup.enter.native="login" show-password>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-row :gutter="24">
                <el-col :span="13" class="captcha-col">
                  <el-input
                    v-model="ruleForm.captcha"
                    :placeholder="$t('pages.wording.inputCaptcha')"
                    @keyup.enter.native="login"
                  >
                  </el-input>
                </el-col>
                <el-col :span="8">
                  <img :src="captcha.base64string" class="captcha-img" @click="refreshCaptcha" />
                </el-col>
              </el-row>
            </el-form-item>
          </div>
          <div class="loginBtn">
            <el-button class="deep-blue-button" @click="login" type="primary">SIGN IN</el-button>
          </div>
        </div>
        <!--loginLeftBox-->
      </div>
      <!--loginBox-->
    </el-form>
    <el-dialog title="" width="100" :visible.sync="showQRCode" :modal-append-to-body="false">
      <p style="text-align: center">
        <img :width="widthQRCode" src="../assets/img/home_QRCode.png" />
      </p>
    </el-dialog>
  </div>
</template>

<script>
import { store } from "@/store/store.js"
import { setCookie } from "../utils/cookie"
import { api } from "@/utils/api"
import { utils } from "@/utils/utils.js"
import _ from "lodash"

export default {
  name: "PageLogin",
  data() {
    return {
      ruleForm: {
        NTAccount: "",
        PS: "",
        captcha: "",
      },
      rules: {
        NTAccount: [{ required: true, message: this.$t("pages.wording.requiredInput"), trigger: "change" }],
        PS: [{ required: true, message: this.$t("pages.wording.requiredInput"), trigger: "change" }],
      },
      loading: false,
      showQRCode: false,
      screenWidth: window.innerWidth,
      widthQRCode: "50%",
      captcha: {
        id: "",
        base64string: "",
      },
    }
  },
  mounted() {
    this.init()
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize)
    })
  },
  methods: {
    init() {
      this.refreshCaptcha()
    },
    refreshCaptcha() {
      let vueInstance = this
      api
        .apiGetCaptcha()
        .then((response) => {
          vueInstance.captcha.id = response.data.captchaId
          vueInstance.captcha.base64string = response.data.captchaBase64String
        })
        .catch((error) => {
          console.log(error)
        })
    },
    removeLoading() {
      this.loading = false
    },
    onResize() {
      this.screenWidth = window.innerWidth
      this.widthQRCode = window.innerWidth < 800 ? "100%" : "50%"
    },
    login() {
      let vueInstance = this
      this.$refs["ruleForm"].validate((valid) => {
        vueInstance.loading = true
        let email = vueInstance.ruleForm.NTAccount
        if (valid) {
          let parameter = {
            username: email,
            pwd: vueInstance.ruleForm.PS,
            captchaId: vueInstance.captcha.id,
            captchaNumber: vueInstance.ruleForm.captcha,
          }
          api
            .apiGetLDPA(parameter)
            .then((response) => {
              if (response.data != "") {
                let token = response.data.access_token
                if (token === "") {
                  vueInstance.removeLoading()
                  utils.showMessage(vueInstance, vueInstance.$t("message.alert").loginfail)
                  return
                }
                setCookie(process.env.VUE_APP_AUTH_TOKEN_NAME, token, 1000 * 60 * 60 * 5.5)
                api
                  .apiGetCurrentUser()
                  .then((response) => {
                    if (response.data) {
                      //todo:alter name of property in api
                      let areas = response.data.areaRoleRights.map((a) => a.area)
                      let regions = response.data.areaRoleRights.map((a) => a.region)
                      let userData = {
                        userAD: response.data.userNT,
                        userEmail: response.data.userMail,
                        userPhone: response.data.userPhone,
                        userName: response.data.userName,
                        userDept: response.data.userDept,
                        userEmpID: response.data.userID,
                        userLoginRole: response.data.systemRoles ?? [],
                        functionAreas: response.data.functionMappingAreas,
                        factory: null,
                        area: response.data.isAdmin ? null : areas,
                        region: response.data.isAdmin ? null : response.data.region,
                        isAdmin: response.data.isAdmin,
                        isApprovalRole: response.data.isApprovalRole,
                        areaRights: response.data.isAdmin
                          ? null
                          : _.map(response.data.areaRoleRights, function (n) {
                              return _.omit(n, "roleList")
                            }),
                        menu: response.data.menu,
                        systemFunctions: response.data.systemFunctions,
                      }

                      userData.enableAreaSelection = userData.isAdmin || areas?.length > 1
                      store.dispatch("setUserProfile", userData)
                      window.location.href = process.env.VUE_APP_APP_URL
                    } else {
                      vueInstance.$router.push({ path: "/nopermission" })
                    }
                    vueInstance.removeLoading()
                  })
                  .catch((error) => {
                    vueInstance.removeLoading()
                    console.log(error)
                    utils.showMessage(vueInstance, "There is an error occurred when get user's info.")
                  })
              }
            })
            .catch((error) => {
              if (error.response.status === 400) {
                vueInstance.removeLoading()
                utils.showMessage(vueInstance, error.response.data.messages[0])
                vueInstance.refreshCaptcha()
                return
              }
              vueInstance.removeLoading()
              console.log(error)
              utils.alertMessage(vueInstance, 1, "loginerror")
            })
        } else {
          console.log("some field is not allowed to be null")
          vueInstance.removeLoading()
          return false
        }
      })
    },
  },
}
</script>

<style>
.PageLogin {
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background-color: #00a0e9;
  z-index: 500;
}
#login {
  width: 100%;
  height: 100%;
}
.loginInnerBox {
  background: #fff;
  padding: 2rem;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  border-radius: 20px;
}
.icon img {
  margin-bottom: 2rem;
}
.loginBox {
  z-index: 100;
  width: 400px;
  min-height: 300px;
  position: absolute;
  top: 100px;
  left: 50%;
  margin-left: -200px;
}
.loginTitle {
  margin: 2rem;
  color: #000;
  font-size: 1.5rem;
  text-align: center;
}
.loginTitle p {
  margin: 0px;
}
.loginTitle p:nth-child(1) {
  font-size: 30px;
}
.loginInput {
  margin: 20px 30px 0px 30px;
}
.loginInput input {
  margin-bottom: 10px;
}
.loginBtn {
  text-align: center;
  margin: 2rem 0;
}
.deep-blue-button,
.deep-blue-button:focus {
  /*background: #0a64a1;*/
  background: #007bff;
  color: #fff;
  border-color: #009ae0;
  outline: none;
  ox-shadow: none;
  box-shadow: 0 2px #0077ad;
}
.deep-blue-button:hover {
  background: #20b9ff;
  color: #fff;
  border-color: #009ae0;
}
.deep-blue-button:active {
  transform: translateY(1px);
  box-shadow: 0 1px #0077ad;
}
.loginRightBox div:nth-child(1) {
  font-size: 30px;
  font-weight: bolder;
  margin-top: 110px;
  text-align: center;
}
.loginRightBox div:nth-child(2) {
  font-size: 10px;
  font-weight: 500;
  margin-right: 15px;
  text-align: right;
}
.loginRightBox img {
  width: 50%;
  position: absolute;
  right: 15px;
  bottom: 30px;
}
</style>
